// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Alert from "src/components/shared/alerts/Alert/Alert";

import powerButton1Img from "src/assets/images/operating-manual/instructions-for-use/power-button-1.png";
import powerButton2Img from "src/assets/images/operating-manual/instructions-for-use/power-button-2.png";
import headsetButtonImg from "src/assets/images/operating-manual/instructions-for-use/headset-button.png";
import controllerButtonImg from "src/assets/images/operating-manual/instructions-for-use/controller-button.png";
import blueLightImg from "src/assets/images/operating-manual/instructions-for-use/blue-light.png";

const TurningOnVRDevice = () => {
  const { t } = useTranslation("operating-manual");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Grid container rowGap="20px">
        <Grid
          item
          xs={12}
          sm={3}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img src={headsetButtonImg} width="100%" alt="headset-button" />
        </Grid>

        <Grid
          item
          xs={12}
          sm={9}
          sx={{
            display: "flex",
            alignItems: "center",
            pl: { xs: "0px", sm: "20px" },
          }}
        >
          <Box>
            1. {t("Turn on the VR device by pressing the")}
            <Box
              component="img"
              src={powerButton1Img}
              alt="power-button"
              sx={{ mx: "8px" }}
              style={{
                display: "inline",
                width: "40px",
                height: "40px",
                verticalAlign: "middle",
              }}
            />
            {t(
              "power button for 2 seconds until the status indicator light is blue"
            )}
            <Box
              component="img"
              src={blueLightImg}
              alt="blue-indicator"
              style={{
                display: "inline",
                width: "45px",
                height: "40px",
                verticalAlign: "middle",
              }}
            />
          </Box>
        </Grid>
      </Grid>

      <Grid container rowGap="20px">
        <Grid
          item
          xs={12}
          sm={3}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src={controllerButtonImg}
              width="100%"
              alt="controller-button"
            />
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          sm={9}
          sx={{
            display: "flex",
            alignItems: "center",
            pl: { xs: "0px", sm: "20px" },
          }}
        >
          <Box>
            2. {t("Turn on one controller by pressing the")}
            <Box
              component="img"
              src={powerButton2Img}
              alt="power-button"
              sx={{ mx: "4px" }}
              style={{
                display: "inline",
                width: "40px",
                height: "40px",
                verticalAlign: "middle",
              }}
            />
            {t("power button for 1 second until the status indicator is blue")}
            <Box
              component="img"
              src={blueLightImg}
              alt="blue-indicator"
              style={{
                display: "inline",
                width: "45px",
                height: "40px",
                verticalAlign: "middle",
              }}
            />
          </Box>
        </Grid>
      </Grid>

      <Alert
        variant="info"
        alertContent={t(
          "Note: You will only need to turn on one controller at a time. Either controller will work."
        )}
      />
    </Box>
  );
};

export default TurningOnVRDevice;
